export default "__VITE_ASSET__63105226__"